/** Замена всех вхождений плейсхолдера. Строковый `String.prototype.replace`
 *  не годится: он меняет только первое вхождение и раскрывает `$`-паттерны
 *  (`$&`, `$'`) из подставляемого значения, корёжа URL. */
const substitute = (url: string, placeholder: string, value: string): string =>
    url.replaceAll(placeholder, () => value);

/** Подстановка плейсхолдеров конфигурационного URL-шаблона:
 *  `{docId}`, `{location.*}` и `{<ключ строки>}` (та же цепочка живёт
 *  в легаси OpenDocButton/OpenUrlExecutor — сводить сюда по мере миграции). */
export function resolveUrlTemplate(
    template: string,
    { docId, row }: { docId?: string; row?: Record<string, unknown> } = {},
): string {
    let url = template;
    const substitutions: [string, string][] = [
        ['{docId}', docId ?? ''],
        ['{location.origin}', window.location.origin],
        ['{location.href}', window.location.href],
        ['{location.hash}', window.location.hash],
        ['{location.host}', window.location.host],
        ['{location.hostname}', window.location.hostname],
        ['{location.pathname}', window.location.pathname],
        ['{location.protocol}', window.location.protocol],
        ['{location.port}', window.location.port],
        ['{location.search}', window.location.search],
    ];
    for (const [placeholder, value] of substitutions) {
        url = substitute(url, placeholder, value);
    }
    if (row) {
        for (const key of Object.keys(row)) {
            url = substitute(url, `{${key}}`, String((row[key] as string | number | undefined) ?? ''));
        }
    }
    return url;
}
